export default {
  start: {
    action: '',
    info: '',
    title: '',
  },
  detail: {
    leaveConfirmation: '',
    leaveTitle: '',
    title: '',
  },
};



// WEBPACK FOOTER //
// ./js/lang/en/advisory.js